<template>
  <div
    class="flex justify-between gap-1 overflow-auto max-h-[calc(100vh_-_180px)]"
  >
    <div class="w-4xl">
      <el-form size="mini" label-position="top">
        <el-form-item label="Subject">
          <el-input v-model="email.subject" />
        </el-form-item>
        <el-form-item label="Content">
          <e-editor :html.sync="email.content" :height="600" />
        </el-form-item>
        <dropzone url="/api/v1/attachments" :target="{ shared: true }" />
        <el-form-item>
          <el-button type="primary" @click="sendEmails" :disabled="!emailable"
            >Send Email</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="w-96 box">
      <div class="box-title">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="selectAllTenants"
          >Select All</el-checkbox
        >
      </div>
      <div class="box-content overflow-auto max-h-[calc(100%_-_50px)]">
        <el-checkbox-group v-model="email.subdomains" @change="tenantChanged">
          <el-checkbox
            v-for="tenant in tenants"
            :label="tenant.subdomain"
            :key="tenant.subdomain"
            style="width: 250px; margin-left: 5px"
            >{{ tenant.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Emails",
  data() {
    return {
      email: {
        subject: "",
        content: "",
        subdomains: [],
      },
      checkAll: false,
      tenants: {},
      isIndeterminate: false,
    };
  },
  created() {
    this.fetchTenants();
  },
  computed: {
    emailable() {
      return (
        !this.isEmptyData(this.email.subject) &&
        !this.isEmptyData(this.email.content) &&
        !this.isEmptyData(this.email.subdomains)
      );
    },
  },
  methods: {
    fetchTenants() {
      this.$http
        .get("/system/tenants.json")
        .then((response) => {
          this.tenants = response.data;
        })
        .catch((err) => {});
    },
    selectAllTenants(val) {
      this.email.subdomains = val ? this.tenants.map((o) => o.subdomain) : [];
      this.isIndeterminate = false;
    },
    tenantChanged(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.tenants.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tenants.length;
    },
    sendEmails() {
      const { subject, content, subdomains } = this.email;
      this.$http
        .post("/system/tenants/emails.json", { subject, content, subdomains })
        .then((response) => {
          this.$message({
            message: "The emails were sent to active tenants successfully",
            type: "success",
          });
        })
        .catch((err) => {});
    },
  },
};
</script>
